var account = "Cuenta";
var accountSettings = "Ajustes de la cuenta";
var charging = "Carga";
var contactInfo = "Información de contacto";
var dashboard = "Panel de control";
var home = "Inicio";
var myProducts = "Mis productos";
var orderHistory = "Historial de pedidos";
var paymentMethod = "Método de pago";
var profileSettings = "Configuración del perfil";
var referAndEarn = "Recomendar y ganar";
var signOut = "Cerrar sesión";
var es_ES = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, es_ES as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
